import React, { useEffect, useState, useRef } from 'react'
import { useAuth } from '../../context/AuthContext'
import { database } from '../../firebase'
import { Input, Flag, MoContainer, MoSpan, Alert } from '../../Mo7/mo7UI'
import { SUBSCRIPTION_STATES } from '../../services/data.service'
import { cols, icons } from '../../services/design.sevice'
import { useTrail } from '@react-spring/core';
import { animated } from '@react-spring/web';


const MESSAGING_GROUP_LIST = {
    MY_ANNOUNCEMENTS: "MyAnnouncements",
    MY_SUBSCRIBTIONS: "MySubscribtions",
}

export default function Messages() {
    const { currentUser } = useAuth()

    const [announcements, setAnnouncements] = useState([])
    const [subscribedToAnnouncements, setSubscribedToAnnouncements] = useState([])

    const [activeAnnouncementId, setActiveAnnouncementId] = useState("")
    const [activeGroupList, setActiveGroupList] = useState(MESSAGING_GROUP_LIST.MY_ANNOUNCEMENTS)


    const [messageRoom, setMessageRoom] = useState([])
    const [msg, setMsg] = useState("")

    const [loading, setLoading] = useState(false)
    // const [notificationPopAnnId, setNotificationPopAnnId] = useState("")

    const refDivMessagesScroll = useRef()

    //get user annoucements 
    useEffect(() => {
        return database.announcements.where("uid", "==", currentUser.uid)
            .onSnapshot(snapshot => {
                setAnnouncements(snapshot.docs.map(database.formattedDoc))
            })
    }, [currentUser.uid])

    //notification pop
    // useEffect(() => {
    //     if (messageRoom?.length > 0 && currentUser.uid !== messageRoom[messageRoom?.length - 1].fromUid) {
    //         setNotificationPopAnnId(activeAnnouncementId)
    //     }
    // }, [messageRoom?.length ,activeAnnouncementId])

    // get user messages
    useEffect(() => {
        setMessageRoom([])
        return database.messageRooms.where("announcement_id", "==", activeAnnouncementId)
            .orderBy("createdAt")
            .onSnapshot(snapshot => {
                setMessageRoom(snapshot.docs.map(database.formattedDoc))
            })
    }, [activeAnnouncementId])

    //get subscribed to announcements
    useEffect(() => {
        return database.announcements.where(`subscribers.${currentUser.uid}.state`, "==", SUBSCRIPTION_STATES.ACCEPTED)
            .onSnapshot(snapshot => {
                setSubscribedToAnnouncements(snapshot.docs.map(database.formattedDoc))
            })
    }, [currentUser.uid])
    function scrollToLatestMessage() {
        refDivMessagesScroll.current?.scrollIntoView({ behavior: "smooth" })

    }
    async function handleSendMessage(e) {
        e.preventDefault()
        if (loading) return
        if (msg.trim().length <= 0) return console.log("empty Message")
        if (activeAnnouncementId.trim().length <= 0) return console.log("empty active AnnouncementId")


        try {
            // setError("")
            setLoading(true)
            setMsg("")
            //get doccumet 
            await database.messageRooms.add({
                announcement_id: activeAnnouncementId,
                from: currentUser.displayName,
                photoURL: currentUser.photoURL,
                fromUid: currentUser.uid,
                text: msg,
                createdAt: database.getCurrentTimeStamp()
            })
            scrollToLatestMessage()

        } catch (er) {
            console.log(er)
            // setError("Failed to Create Announcement"+e)
        }
        setLoading(false)

    }

    //#region animations
    const anim_announcements = useTrail(announcements.length, {
        from: {
            opacity: 0,
            y: 100
        },
        to: {

            opacity: 1,
            y: 0
        }
    })
    const anim_subscribedToAnnouncements = useTrail(subscribedToAnnouncements.length, {
        from: {
            opacity: 0,
            y: 100
        },
        to: {

            opacity: 1,
            y: 0
        }
    })
    const anim_Messages = useTrail(messageRoom.length, {
        from: {
            opacity: 0,
            x: -50
        },
        to: {

            opacity: 1,
            x: 0
        }
    })

    //#endregion
    //#region Dom
    const domAnnouncements = announcements.map((ele, i) => {
        return (<animated.div style={anim_announcements[i]}>
            <MoContainer pos="relative" key={ele.id} bg={activeAnnouncementId === ele.id ? "#ddd" : "white"} sdw={{ x: 0, y: "5px", sprd: ".15rem", op: "rgba(0,0,0,0.1)" }} onClick={function () { setActiveAnnouncementId(ele.id); scrollToLatestMessage() }} cursor='pointer' b_r={{ all: "2rem" }} eff_shdw={{ op: .2 }} h='3.5rem' flex align="center">
                {/* {notificationPopAnnId === ele.id && <MoContainer pos="absolute" wh="15px" bg={cols.red} pos_dir={{ t: '5px', l: "5px" }} b_r={{ all: "1rem" }} />} */}
                <MoContainer m_l=".5rem" eff_size={{ val: 1.2 }} bg_i={ele.photoURL} border={{ w: "2px", col: cols.mainDark_1 }} b_r={{ all: "12rem" }} wh="2.5rem" />
                <MoContainer flex align="center" h="1.3rem">
                    <Flag text={ele.groupChatLabel} bg={cols.mainLight_1} col={cols.main_blue} />
                </MoContainer>
            </MoContainer>
        </animated.div>
        )
    })
    const domSubscribedToAnnouncements = subscribedToAnnouncements.map((ele, i) => {
        return (<animated.div style={anim_subscribedToAnnouncements[i]}><MoContainer key={ele.id} bg={activeAnnouncementId === ele.id ? "#ddd" : "white"} sdw={{ x: 0, y: "5px", sprd: ".15rem", op: "rgba(0,0,0,0.1)" }} onClick={function () { setActiveAnnouncementId(ele.id); scrollToLatestMessage() }} cursor='pointer' b_r={{ all: "2rem" }} eff_shdw={{ op: .2 }} h='3.5rem' flex align="center">
            <MoContainer m_l=".5rem" eff_size={{ val: 1.2 }} bg_i={ele.photoURL} border={{ w: "2px", col: cols.mainDark_1 }} b_r={{ all: "12rem" }} wh="2.5rem" />
            <MoContainer flex align="center" h="1.3rem">
                <Flag text={ele.displayName} bg={cols.mainLight_1} col={cols.main_blue} />
                <Alert disabled>{ele.subject}</Alert>
            </MoContainer>
        </MoContainer></animated.div>)
    })


    const domMessages = messageRoom.map((ele, i) => {
        return (<animated.div style={anim_Messages[i]}>
            <MoContainer key={ele.id} >
                {currentUser.uid === ele.fromUid
                    ? <MoContainer flex flex_dir_c align="flex-end" pos="relative">
                        {/* <MoContainer bg_i={ele.photoURL} b_r={{ all: "12rem" }} wh="2.5rem" /> */}
                        <Flag b_r={{ all: ".5rem" }} text={ele.text} bg={cols.green} />
                        {/* <MoContainer pos="absolute" pos_dir={{t:".5rem",r:"3rem"}}> <MoSpan fs_sml >{ele.from}</MoSpan> </MoContainer> */}
                    </MoContainer>
                    : <MoContainer flex flex_dir_c align="flex-start" pos="relative">
                        <MoContainer bg_i={ele.photoURL} b_r={{ all: "12rem" }} wh="2.5rem" />
                        <Flag b_r={{ all: ".5rem" }} text={ele.text} col={cols.mainDark_1} />
                        <MoContainer pos="absolute" pos_dir={{ t: ".65rem", l: "3rem" }}> <MoSpan f_size=".85rem" >{ele.from}</MoSpan> </MoContainer>
                    </MoContainer>
                }
            </MoContainer></animated.div>)
    })


    //#endregion

    return (
        <MoContainer >
            {/* Header */}
            <MoContainer h="5rem" flex align="center">
                <MoSpan fs_mid m_r="auto" m_l="auto"> My Messages </MoSpan>
            </MoContainer>
            {/* Container */}
            <MoContainer grid tem_c='.7fr 1fr ' pos="relative" h="calc(100vh - 6rem)" >
                {/* sidebar */}
                <MoContainer flex flex_dir_c gap="3rem" bg={cols.mainLight_1} align="center" justify="center" z="1" pos="absolute" w="3rem" pos_dir={{ t: 0, l: 0, b: 0 }}>
                    <MoContainer cursor="pointer"
                        sdw={activeGroupList === MESSAGING_GROUP_LIST.MY_ANNOUNCEMENTS && { op: .2 }}
                        border={{ w: "2px", col: "white" }} onClick={function () { setActiveGroupList(MESSAGING_GROUP_LIST.MY_ANNOUNCEMENTS); setActiveAnnouncementId("") }} b_r={{ all: "3rem" }} eff_shdw={{ col: cols.gray }} wh="2.3rem" grid place="center" >
                        <img width="18px" src={icons.ic_library_books} alt="" />
                    </MoContainer>
                    <MoContainer cursor="pointer" border={{ w: "2px", col: "white" }} onClick={function () { setActiveGroupList(MESSAGING_GROUP_LIST.MY_SUBSCRIBTIONS); setActiveAnnouncementId("") }} b_r={{ all: "3rem" }} eff_shdw={{ col: cols.gray }} wh="2.3rem" grid place="center" >
                        <img width="18px" src={icons.ic_textsms} alt="" />
                    </MoContainer>
                </MoContainer>

                {/* contact */}
                <MoContainer scroller={{ col: "#fff" }} pos="relative" flow_y="scroll" >
                    <MoContainer w="100%" z="2" pos="absolute" pos_dir={{ t: 0 }}>
                        <MoContainer>
                            <Flag text={activeGroupList === MESSAGING_GROUP_LIST.MY_ANNOUNCEMENTS ? "My Announcements" : "My Subscriptions"} isActive />
                        </MoContainer>
                    </MoContainer>
                    <MoContainer flex flex_dir_c gap="1rem" pd={{ t: "3rem", l: "3.5rem", r: '1rem', b: "2rem" }}>
                        {activeGroupList === MESSAGING_GROUP_LIST.MY_ANNOUNCEMENTS
                            ? (domAnnouncements.length > 0 ? domAnnouncements : <Flag bg={cols.mainLight_1} col={cols.main_purple} text="You Don't have Any Announcements :p " />)
                            : (domSubscribedToAnnouncements.length > 0 ? domSubscribedToAnnouncements : <Flag bg={cols.mainLight_1} col={cols.main_purple} text="You Are Not Subscribed To Any Announcement :p " />)

                        }

                    </ MoContainer>
                </MoContainer>

                {/* messages */}
                <MoContainer grid tem_r='1fr .15fr' pd={{ r: "2rem" }}>
                    {/* chat */}
                    <MoContainer flex flex_dir_c bg={cols.mainLight_1} scroller={{ col: "transparent" }} flow_y="scroll" max_h="25rem" pd={{ all: "1rem" }} b_r={{ all: "10px" }} >
                        {activeAnnouncementId.length <= 0 && <Alert info > Choose A Group Chat 🙃 </Alert>}
                        {domMessages}
                        {domMessages.length <= 0 && activeAnnouncementId.length > 0 && <Alert info > Nothing Is Here :p </Alert>}
                        {/* scroll to div */}
                        <div ref={refDivMessagesScroll} />
                    </MoContainer>

                    {/* send button */}
                    <form onSubmit={handleSendMessage}>
                        <MoContainer flex align="center" justify="space-between" pd={{ lr: "1rem" }} bg={cols.mainLight_1} b_r={{ all: "10px" }} >
                            <Input onChange={(e) => setMsg(e.target.value)} value={msg} type="text" w="80%" pholder=". . ." />
                            <MoContainer onClick={handleSendMessage} grid hvr={`background-color:${cols.main_purple};`} place="center" eff_shdw={{ op: .2 }} bg={loading ? cols.gray : cols.green} h="3rem" w="3rem" b_r={{ all: "10px" }}>
                                <img width="20px" src={icons.ic_message} alt="" />
                            </MoContainer>
                        </MoContainer>
                    </form>
                </MoContainer>
            </MoContainer>

        </MoContainer>
    )
}
